// Dates with the day as an ordinal: "30ᵗʰ October 2026", "1ˢᵗ Jun", "Fri 2ⁿᵈ Oct". Used after any en-GB date that
// names the month:  d.toLocaleDateString('en-GB', { … }).replace(DAY_MONTH, ordinalDay)
// The small letters are Unicode superscripts, so they work in any string (titles, PDFs drawn from the page, emails).
// PDFs the server draws with its own fonts use ordinalDayPlain ("30th"), as those fonts may not have them.

const SMALL: Record<OrdinalSuffix, string> = { st: 'ˢᵗ', nd: 'ⁿᵈ', rd: 'ʳᵈ', th: 'ᵗʰ' }
type OrdinalSuffix = 'st' | 'nd' | 'rd' | 'th'

export function ordinalSuffix(day: number): OrdinalSuffix {
  if (day % 100 >= 11 && day % 100 <= 13) return 'th'
  return (['th', 'st', 'nd', 'rd'][day % 10] as OrdinalSuffix | undefined) ?? 'th'
}

/** A day number followed by a month name ("30 October", "05 Oct"). */
export const DAY_MONTH = /\b(\d{1,2})(?=\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\b)/g

/** Replacer for DAY_MONTH: the day with small ordinal letters ("05" → "5ᵗʰ"). */
export const ordinalDay = (_match: string, day: string): string => `${Number(day)}${SMALL[ordinalSuffix(Number(day))]}`

/** Replacer for DAY_MONTH with ordinary letters ("30th"), for the server's own PDF fonts. */
export const ordinalDayPlain = (_match: string, day: string): string => `${Number(day)}${ordinalSuffix(Number(day))}`

/** Adds the ordinal to every day-and-month in a piece of text. */
export const withOrdinals = (text: string): string => text.replace(DAY_MONTH, ordinalDay)
